export { default } from "./AssignmentsCompleteIcon";
